import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';


@Injectable()
export class RedirectService {

    private GOOGLE_LOGIN = 'google-login-success';
    private LOCAL_LOGIN = 'local-login-success';

    constructor(private router: Router) { }

    /**
     * 窓口担当者がログイン時点の画面URLを一時保存する
     * 
     * @param routerUrl 
     */
    setRedirectUrl(routerUrl: string): void {
        if (window.sessionStorage) {
            window.sessionStorage.setItem(this.GOOGLE_LOGIN, routerUrl);
        }
    }

    /**
     * 窓口担当者ログイン後、ログイン前の画面に遷移する
     */
    redirect() {
        if (window.sessionStorage && window.sessionStorage.getItem(this.GOOGLE_LOGIN)) {
            let routerUrl = window.sessionStorage.getItem(this.GOOGLE_LOGIN);

            if (routerUrl == '/input') {
                this.router.navigate(['/list']);
            } else {
                window.sessionStorage.removeItem(this.GOOGLE_LOGIN);
                this.router.navigate([routerUrl]);
            }

        } else {
            this.router.navigate(['/list']);
        }
    }
}



// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/services/page/redirect.service.ts